var exports = {
  "k": "xdbfd91f1--156ae5--container",
  "T": "xdbfd91f1--156ae5--map",
};

module.exports = exports;
